// extracted by mini-css-extract-plugin
module.exports = {"typeSelect":"style-module_typeSelect_Qbo9n","verticalCell":"style-module_verticalCell_2_Zji"};